import { AnimalKind, IEsfFeedCurve, IProcessEquipmentData } from 'shared/api/api';
import { Option } from 'react-dropdown';
import { ExtractLocationCode } from './process-equipment-helper/process-equipment-helper';
import { StoreContainer } from 'shared/state/store-container';
import { getEsfFeedCurveAnimalKind } from './animal-kinds-helpers';

export function generateFeedCurveOptions(availableCurves: IEsfFeedCurve[]) {
    let options: Option[] = [];

    options = availableCurves.map(curve => {
        return {
            label: curve.feedCurveName
                ? `${curve.feedCurveNumber} - ${curve.feedCurveName}`
                : curve.feedCurveNumber !== undefined && curve.feedCurveNumber !== null
                    ? curve.feedCurveNumber.toString()
                    : '',
            value:
                curve.feedCurveNumber !== undefined && curve.feedCurveNumber !== null
                    ? curve.feedCurveNumber.toString()
                    : '',
            objectData: getEsfFeedCurveAnimalKind(curve.feedCurveType)
        } as Option;
    });

    options.unshift({ label: ' ', value: '' });

    return options;
}

export function generateFeedCurveOptionsByLocation(
    availableCurves: IEsfFeedCurve[],
    peq: IProcessEquipmentData | undefined,
) {
    let options: Option[] = [];

    if (peq) {
        options = availableCurves
            .filter(
                curve =>
                    curve.feedCurveName && curve.locationCode && curve.locationCode === ExtractLocationCode(peq.code),
            )
            .map(curve => {
                return {
                    label: curve.feedCurveName
                        ? curve.feedCurveName
                        : curve.feedCurveNumber !== undefined && curve.feedCurveNumber !== null
                            ? curve.feedCurveNumber.toString()
                            : '',
                    value:
                        curve.feedCurveNumber !== undefined && curve.feedCurveNumber !== null
                            ? curve.locationCode + '-' + curve.feedCurveNumber.toString()
                            : '',
                    objectData: getEsfFeedCurveAnimalKind(curve.feedCurveType)
                } as Option;
            });
    }

    options.unshift({ label: ' ', value: '' });

    return options;
}

export function generateFeedCurveOptionsWithLocationCode(availableCurves: IEsfFeedCurve[]) {
    let options: Option[] = [];

    options = availableCurves.map(curve => {
        return {
            label: curve.feedCurveName
                ? curve.feedCurveName
                : curve.feedCurveNumber !== undefined && curve.feedCurveNumber !== null
                    ? curve.feedCurveNumber.toString()
                    : '',
            value:
                curve.feedCurveNumber !== undefined && curve.feedCurveNumber !== null
                    ? curve.locationCode + '-' + curve.feedCurveNumber.toString()
                    : '',
            objectData: getEsfFeedCurveAnimalKind(curve.feedCurveType)
        } as Option;
    });

    options.unshift({ label: ' ', value: '' });

    return options;
}
export const getFeedCurvesByPenId = (penId: string | undefined) => {
    if (penId) {
        const state = StoreContainer.getState();
        const utp = state.unitToPenData.data.find(p => p.penId === penId);
        const processEquipmentData = state.processEquipmentData.entities.find(
            peq => utp && peq.id === utp.processEquipmentDataId,
        );
        if (processEquipmentData) {
            return state.esfStatus.availableCurves.filter(
                curve =>
                    curve.feedCurveName &&
                    curve.locationCode &&
                    curve.locationCode === ExtractLocationCode(processEquipmentData.code),
            );
        }
    }

    return [];
};

export const sanitizeFeedCurveName = (feedCurveName: string) => {
    const split = feedCurveName.split('-');
    return split[split.length - 1].trim();
}

export const filterElistarFeedCurvesByAnimalKind = (feedCurves: Option, animalKind: string | undefined) => {
    return feedCurves.objectData === animalKind || animalKind === AnimalKind.YoungAnimal && feedCurves.objectData === AnimalKind.YoungFemale;
}